import { useContext } from 'react'
import { CartContext } from 'components/booking/context/cartContext'
import { Caption1, BodySemi } from 'components/common/typography'
import { MainContainer, Triangle } from './bookingCountdownTooltip_styles'

const BookingCountdownTooltip = () => {
  const { remainingTime } = useContext(CartContext)
  if (remainingTime < 0) { return null }

  const secondsToTime = seconds => (isNaN(+seconds) ? '0' : `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`)

  return (
    <MainContainer>
      <Caption1>
        Check out within
        <BodySemi as='span'>
          {` ${secondsToTime(remainingTime)} `}
        </BodySemi>
        minutes
      </Caption1>
      <Triangle viewBox='0 0 20 12' width='20'>
        <path d='M10 0 L20 12 L0 12 Z' />
      </Triangle>
    </MainContainer>
  )
}

export default BookingCountdownTooltip
